// extracted by mini-css-extract-plugin
export default {"imageSkeleton":"LandingFeaturedEditionsSkeleton_imageSkeleton__tbus5"};